import React, { useState } from 'react';
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import SettingsBrightnessIcon from '@mui/icons-material/SettingsBrightness';
import CheckIcon from '@mui/icons-material/Check';
import { ColorPreference, useColorMode } from '../contexts/ColorModeContext';

const OPTIONS: { value: ColorPreference; label: string; icon: React.ReactNode }[] = [
  { value: 'light', label: 'Light', icon: <LightModeIcon fontSize="small" /> },
  { value: 'dark', label: 'Dark', icon: <DarkModeIcon fontSize="small" /> },
  { value: 'system', label: 'Match my computer', icon: <SettingsBrightnessIcon fontSize="small" /> },
];

/** Light, dark, or follow the computer — in the top bar, remembered per browser. */
export const ColorModeToggle: React.FC = () => {
  const { preference, mode, setPreference } = useColorMode();
  const [anchor, setAnchor] = useState<HTMLElement | null>(null);
  return (
    <>
      <Tooltip title="Appearance">
        <IconButton color="inherit" aria-label="Appearance" onClick={e => setAnchor(e.currentTarget)} sx={{ mr: 1 }}>
          {preference === 'system' ? <SettingsBrightnessIcon /> : mode === 'dark' ? <DarkModeIcon /> : <LightModeIcon />}
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        {OPTIONS.map(o => (
          <MenuItem key={o.value} selected={preference === o.value} onClick={() => { setPreference(o.value); setAnchor(null); }}>
            <ListItemIcon>{o.icon}</ListItemIcon>
            <ListItemText>{o.label}</ListItemText>
            {preference === o.value && <CheckIcon fontSize="small" sx={{ ml: 2 }} />}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
